module.exports = __webpack_public_path__ + "./img/well-done-banner.png";